<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->
<!--Todo finalise the product selector -->
<template>
  <div
    class="no-select"
    :class="{'bulk-selection-busy': bulk_selection_in_progress}"
    v-if="FilterBox !== null"
  >
    <v-navigation-drawer
      v-show="drawerOpen"
      v-model="drawerOpen"
      app
      class="grey lighten-4 pl-2 pr-2 font-weight-light"
      clipped
      fixed
      stateless="stateless"
      temporary
      width="570"
    >
      <v-row no-gutters class="mt-1">
        <v-col>
          <v-row v-if="!loading">
            <v-col sm="auto" class="mt-0 pt-0 mb-0 pb-0  justify-space-around ml-auto">
              <v-btn
                :class="apply_button_class"
                :disabled="
                  (product_selections_changed || temp_dsm_combinations_updating) &&
                    !active_from_outside
                "
                elevation="0"
                small
                @click.stop="apply_btn_clicked"
              >
                <v-icon left>mdi-exit-to-app</v-icon>
                Apply
              </v-btn>

              <v-tooltip right>
                <template v-slot:activator="{on, attrs}">
                  <v-btn
                    v-if="
                      $store.state.tradeDSM.dsm_filter_setttings.Filters.META
                        .filter_in_progress
                    "
                    :class="filters_button_class"
                    elevation="0"
                    small
                    @click="clear_preset_filters(false)"
                    v-on="on"
                    :disabled="temp_dsm_combinations_updating"
                  >
                    <v-icon left>mdi-filter-variant-plus</v-icon>
                    Clear Filters
                  </v-btn>
                  <v-btn
                    v-else
                    small
                    @click="reset_filters_to_preset_state(true)"
                    v-on="on"
                    :class="filters_button_class"
                    class="ml-2"
                    :disabled="temp_dsm_combinations_updating"
                  >
                    <v-icon left>mdi-filter-variant-minus</v-icon>
                    Load Filters
                  </v-btn>
                </template>
                <span>{{ filters_load_text }}</span>
              </v-tooltip>

              <v-btn
                class="v-btn--outlined trade-blue white--text ml-1"
                elevation="0"
                small
                @click.stop="cancel_btn_clicked"
              >
                <v-icon left>mdi-cancel</v-icon>
                Cancel
              </v-btn>
              <!-- Cancel Button -->
            </v-col>
          </v-row>
          <v-row class="justify-end" v-else>
            <v-progress-circular
              :width="2"
              class="mr-11 mb-1"
              color="green"
              indeterminate
            ></v-progress-circular>
          </v-row>
          <v-row class="mr-1 mt-1 mb-0 pb-0">
            <v-text-field
              v-model="searchQuery"
              :placeholder="
                `Refine search within ${box_entries_count(
                  0,
                  allow_out_of_cube_items_selections,
                )} ${search_box_text()}`
              "
              :append-icon="searchQuery.length > 0 ? 'mdi-close' : null"
              :prepend-inner-icon="
                selector_type === 'markets' ? 'mdi-earth' : 'mdi-dolly'
              "
              background-color="white"
              class="trade-blue-text mb-0 ml-4 pa-0"
              dense
              flat
              outlined
              solo
              hide-details="true"
              @click:append="searchQuery = ''"
            ></v-text-field>
          </v-row>
          <!-- Search Bar  -->
          <temp-dsm-combintations
            :combinations="current_transaction.combinations"
            :updating="temp_dsm_combinations_updating"
            class="ml-1 mr-1 mt-1 outline"
            :class="{outline_focus: !product_selections_changed}"
            :active="true"
          />
          <!-- Combinations - Product, Market, Combinations  -->

          <v-row no-gutters class="pt-1 pb-2 outline mt-2 ml-1 mr-1  lighten-2">
            <v-col sm="auto"></v-col>
            <!-- Returls Off Toggle Button  -->
            <v-col sm="auto">
              <v-btn
                :disabled="temp_dsm_combinations_updating || product_selections_changed"
                x-small
                @click="update_temp_dsm_combinations"
                class="yellow trade-blue--text ml-2"
              >
                Update Summary
              </v-btn>
            </v-col>
            <v-col sm="auto">
              <form>
                <input
                  type="checkbox"
                  id="checkbox_id"
                  class="ml-2 mt-1"
                  @change="
                    allow_out_of_cube_items_selections_changed(
                      allow_out_of_cube_items_selections,
                    )
                  "
                  v-model="allow_out_of_cube_items_selections"
                />
                <label for="checkbox_id" class="caption ml-2">{{ checkbox_text }}</label
                ><br />
              </form>
            </v-col>
            <v-col sm="auto">
              <form>
                <input
                  type="checkbox"
                  id="checkbox_id"
                  class="ml-2 mt-1"
                  v-model="show_hover"
                />
                <label for="checkbox_id" class="caption ml-2">{{
                  show_hover ? 'Hide Hover' : 'Show Hover'
                }}</label
                ><br />
              </form>
            </v-col>
          </v-row>

          <!--          Search Box-->
          <!--          Search Box-->
          <!--          Search Box-->
          <template v-for="search_box in FilterBox.search_boxes">
            <v-card
              class="flex-grow-1 mt-2"
              :key="search_box.id"
              :height="`${search_box.box_height}vh`"
            >
              <v-card-title
                class="trade-blue white--text pa-0 pl-2 mt-3 font-weight-light"
              >
                <v-layout class="pl-4 pr-4 mb-0 pb-0">
                  <v-row no-gutters>
                    <v-col sm="3">
                      <span class="subtitle-2">{{ search_box.name }}</span>
                    </v-col>
                    <!-- HS6Code  -->
                    <v-col sm="1">
                      <v-tooltip
                        right
                        v-if="
                          FilterBox.show_select_all(
                            search_box.id,
                            allow_out_of_cube_items_selections,
                          )
                        "
                      >
                        <template v-slot:activator="{on, attrs}">
                          <v-btn
                            v-if="
                              FilterBox.show_select_all(
                                search_box.id,
                                allow_out_of_cube_items_selections,
                              )
                            "
                            x-small
                            v-on="on"
                            :disabled="bulk_selection_in_progress"
                            @click="handle_select_all(search_box.id)"
                            class="bulk-selection-action-btn bulk-selection-check-btn mt-2 mb-2 black--text"
                            :style="
                              bulk_selection_in_progress
                                ? 'background-color: #bdbdbd !important; opacity: 1 !important;'
                                : 'background-color: #ffeb3b !important;'
                            "
                          >
                            <v-icon color="black">
                              mdi-check
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Select all {{ search_box.name }} </span>
                      </v-tooltip>
                    </v-col>
                    <v-col sm="1">
                      <v-tooltip right v-if="FilterBox.show_unselect_all(search_box.id)">
                        <template v-slot:activator="{on, attrs}">
                          <v-btn
                            v-if="FilterBox.show_unselect_all(search_box.id)"
                            x-small
                            :disabled="bulk_selection_in_progress"
                            @click="handle_unselect_all(search_box.id)"
                            v-on="on"
                            class="bulk-selection-action-btn mt-2 mb-2 ml-1"
                            :class="
                              bulk_selection_in_progress
                                ? 'grey lighten-1'
                                : 'yellow trade-blue--text'
                            "
                          >
                            <v-icon :color="bulk_selection_in_progress ? 'white' : 'trade-blue'">
                              mdi-close
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Unselect all {{ search_box.name }}</span>
                      </v-tooltip>
                    </v-col>
                    <v-col>
                      <span class="caption float-right mt-2"
                        >Selected:
                        {{ FilterBox.entries_selected_count(search_box.id) }}/{{
                          box_entries_count(
                            search_box.id,
                            allow_out_of_cube_items_selections,
                          )
                        }}</span
                      >
                    </v-col>
                    <v-col sm="1">
                      <help-link
                        :help_id="search_box.help_id"
                        class="ml-6 mt-5"
                      ></help-link>
                    </v-col>
                  </v-row>
                </v-layout>
              </v-card-title>
              <v-virtual-scroll
                :items="FilterBox.box_entry_codes(search_box.id, searchQuery)"
                item-height="21"
                bench="30"
                :height="`${search_box.scroller_height}vh`"
              >
                <template v-slot:default="{index, item}">
                  <v-tooltip :disabled="!show_hover" right max-width="400px">
                    <template v-slot:activator="{on, attrs}">
                      <div v-on="on">
                        <v-row no-gutters>
                          <v-col :cols="search_box.id === 0 ? 12 : 11">
                            <p
                              :class="{
                                active: search_box.code_lookup[item].selected,
                                'ml-2': !(index >= 9),
                                not_selected:
                                  (!search_box.code_lookup[item].in_cube ||
                                    (!search_box.code_lookup[item].selected &&
                                      !search_box.code_lookup[item].partials_list
                                        .length === 0) ||
                                    (search_box.code_lookup[item].partials_list.length ===
                                      0 &&
                                      search_box.id !== 0) ||
                                    (search_box.id === 0 &&
                                      !search_box.code_lookup[item].selected)) &&
                                  !search_box.code_lookup[item].selected,
                                'grey lighten-2': !search_box.code_lookup[item].in_cube,
                              }"
                              class="listItem p_overflow name"
                              @click="entry_click(search_box.id, item)"
                            >
                              <span class="ml-2 font-italic"
                                >{{
                                  search_box.code_lookup[item].selected ? '✓' : index + 1
                                }}

                                <!--                                {{ search_box.code_lookup[item].items }}&#45;&#45;-->
                                <!--                                {{ search_box.code_lookup[item].partials_list }}-->

                                <span
                                  v-if="search_box.code !== search_box.description"
                                  v-html="highlight(item, searchQuery)"
                                >
                                  {{ item }}
                                </span>
                              </span>

                              <span
                                class="mr-2 ml-1"
                                v-html="
                                  highlight(
                                    search_box.code_lookup[item].description.toString(),
                                    searchQuery,
                                  )
                                "
                              >
                              </span>
                              <span v-if="search_box.id > 0" class="mr-2">
                                ({{ represented_items_count(search_box, item) }})
                              </span>
                              <!--                          <span>-->
                              <!--                            {{ search_box.code_lookup[item].partials_list }}-->
                              <!--                          </span>-->
                              <span v-if="!search_box.code_lookup[item].in_cube"
                                >[not in results set]</span
                              >
                            </p></v-col
                          >
                          <template v-if="search_box.id > 0">
                            <v-col class="white">
                              <span
                                v-if="
                                  search_box.code_lookup[item].partials_list.length > 0 &&
                                    !search_box.code_lookup[item].selected
                                "
                                @click="partial_select_all(search_box.id, item)"
                                class="listItem hand"
                                ><v-icon class="mini_box">
                                  mdi-check
                                </v-icon></span
                              >
                              <span
                                v-if="
                                  search_box.code_lookup[item].partials_list.length > 0 &&
                                    !search_box.code_lookup[item].selected
                                "
                                class="listItem hand"
                                @click="
                                  FilterBox.partial_unselect_all(search_box.id, item)
                                "
                                ><v-icon class="mini_box">
                                  mdi-close
                                </v-icon></span
                              >
                            </v-col>
                          </template>
                        </v-row>
                      </div>
                    </template>
                    <span>
                      <span class="d-block">
                        To select or unselect and item, or all sub-items belonging to an
                        item, click directly on the item (yellow) line.<br />
                      </span>
                      <span class="d-block mt-3">
                        To further sub-select (or unselect) items that belongs to only a
                        specific sub-item within the current already selected list of
                        items, use the
                        <v-icon class="mini_box">mdi-check</v-icon> (select) or
                        <v-icon class="mini_box">mdi-close</v-icon> (unselect).</span
                      >
                      <span class="d-block mt-3">
                        See
                        <v-icon
                          class="grey lighten-2 rounded-circle pa-1 black--text help_box"
                        >
                          mdi-help</v-icon
                        >
                        (help) for more information.</span
                      >
                      <span class="blue d-block mt-3 pa-2">
                        {{ item }} -
                        {{ search_box.code_lookup[item].description }}
                        <template v-if="search_box.id > 0">
                          ({{ represented_items_count(search_box, item) }})
                        </template>
                      </span>
                    </span>
                  </v-tooltip>
                </template>
              </v-virtual-scroll>
            </v-card>
          </template>
        </v-col>
      </v-row>
    </v-navigation-drawer>
  </div>
</template>

<script>
import filterHelpers from '@/components/trade-dsm-application/mixins/filter-helpers';
import progressMessageMixin from '@/components/trade-dsm-application/mixins/progress-message';
import load_edit_save_helpers from '@/components/trade-dsm-application/left-side-bar/mixins/load-edit-save-helpers';
import {mapGetters, mapMutations} from 'vuex';
import TempDsmCombintations from '@/components/trade-dsm-application/left-side-bar/filter_componenets/TempDsmCombintations';
import {eventBus} from '@/main';
import {
  MarketFilterBox,
  ProductFilterBox,
} from '@/components/trade-dsm-application/left-side-bar/products/Product-Market-Filterbox-Object';

import {config} from '@/store/config';
import Swal from 'sweetalert2';
import helpLink from '@/components/application-level/help-system/help-link.vue';

const _ = require('lodash');
let settings = filterHelpers.data();

export default {
  name: 'productFilterOptimisedV2',
  mixins: [filterHelpers, progressMessageMixin, load_edit_save_helpers],
  components: {
    helpLink,
    TempDsmCombintations,
  },
  props: {
    visible: Boolean,
    selector_type: String,
  },
  mounted() {
    // set the outside combinations to the selector box values
    this.current_transaction.combinations = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations;

    // this.set_selectors();
    // set up an event to catch opening this box from the outside.
    this.setup_open_from_top_selector_list_box();
  },
  beforeDestroy() {
    this.set_bulk_selection_busy(false);
  },
  data() {
    return {
      FilterBox: null,
      SelectionList: null,
      FilterBox_Products: null,
      FilterBox_Markets: null,
      active_from_outside: false,
      active_from_outside_markets: false,
      active_from_outside_products: false,
      //
      search_boxes_products: [
        // list of objects to create each window from
        {
          id: 0,
          name: 'Code (HS-6)',
          code: 'HS6_Code',
          code_above: null,
          code_below: 'HS4_Code',
          description: 'HS6_Description',
          help_id: 53,
          box_height: settings.products_box_one_vh,
          scroller_height: settings.products_box_one_scroller_vh,
          code_lookup: {},
        },
        {
          id: 1,
          name: 'Heading (HS-4)',
          code: 'HS4_Code',
          code_above: 'HS6_Code',
          code_below: 'HS2_Code',
          description: 'HS4_Description',
          help_id: 54,
          box_height: settings.products_box_two_vh,
          scroller_height: settings.products_box_two_scroller_vh,
          code_lookup: {},
        },
        {
          id: 2,
          name: 'Section (HS-2)',
          code: 'HS2_Code',
          code_above: 'HS2_Code',
          code_below: 'HS2_Groups',
          description: 'HS2_Description',
          help_id: 55,
          box_height: settings.products_box_three_vh,
          scroller_height: settings.products_box_three_scroller_vh,
          code_lookup: {},
        },
        {
          id: 3,
          name: 'Groups',
          code: 'HS2_Groups',
          code_above: 'HS2_Code',
          code_below: null,
          description: 'HS2_Groups',
          help_id: 56,
          box_height: settings.products_box_four_vh,
          scroller_height: settings.products_box_four_scroller_vh,
          code_lookup: {},
        },
      ],
      search_boxes_markets: [
        // list of objects to create each window from
        {
          id: 0,
          name: 'Country',
          code: 'C_Code',
          description: 'C_Name',
          help_id: 50,
          code_above: null,
          code_below: 'Sub_Region',
          box_height: settings.markets_box_one_vh,
          scroller_height: settings.markets_box_one_scroller_vh,
          code_lookup: {},
        },
        {
          id: 1,
          name: 'Sub-Region',
          code: 'Sub_Region',
          description: 'Sub_Region',
          help_id: 51,
          code_above: 'C_Code',
          code_below: 'Main_Region',
          box_height: settings.markets_box_two_vh,
          scroller_height: settings.markets_box_two_scroller_vh,
          code_lookup: {},
        },
        {
          id: 2,
          name: 'Main-Region',
          code: 'Main_Region',
          description: 'Main_Region',
          help_id: 52,
          code_above: 'Sub_Region',
          code_below: null,
          box_height: settings.markets_box_three_vh + 3,
          scroller_height: settings.markets_box_three_scroller_vh + 1,
          code_lookup: {},
        },
      ],
      //
      hs6_code_lookup: {},
      hs4_code_lookup: {},
      hs2_code_lookup: {},
      hs2_groups_code_lookup: {},
      //
      hs6_code_hash_table: {},
      backup_current_seletions_outside_open: [],

      stateless: true, // sidebar setting dont change
      master_list: [],
      allow_out_of_cube_items_selections: false,
      bulk_selection_in_progress: false,
      show_hover: true,
      backup_market_selector_list: [], // will be used to trac changes for apply button, set at drawer open
      searchQuery: '',
      temp_dsm_combinations_updating: false,
      current_transaction: {
        combinations: {
          markets_count: 0,
          products_count: 0,
          combinations: '',
        },
      },
      backup_current_transaction: {
        combinations: {
          markets_count: 0,
          products_count: 0,
          combinations: '',
        },
      },
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['is_run_cube_valid']),

    are_there_out_of_cube_selections() {
      if (this.FilterBox !== null) {
        let cnt = 0;
        for (const k in this.FilterBox.search_boxes[0].code_lookup) {
          if (
            this.FilterBox.search_boxes[0].code_lookup[k].selected === true &&
            this.FilterBox.search_boxes[0].code_lookup[k].in_cube === false
          ) {
            cnt += 1;
          }
        }
        return cnt > 0;
      } else return false;
    },

    filters_load_text() {
      if (
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress
      ) {
        return 'Clear Selected Filters';
      } else {
        return 'Load Default Filters';
      }
    },

    checkbox_text() {
      let return_text = this.allow_out_of_cube_items_selections
        ? 'All ' + this.search_box_text()
        : 'All filtered ' + this.search_box_text();

      if (
        this.are_there_out_of_cube_selections &&
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.filter_in_progress
      ) {
        return_text += ' (some selections might not be in results)';
      }
      return return_text;
    },

    product_selections_changed() {
      if (this.FilterBox !== null) {
        let current_selection = this.FilterBox.selected_items();
        return _.isEqual(current_selection, this.backup_market_selector_list);
      } else return false;
    },

    apply_button_class() {
      return {
        'v-btn--outlined': true,
        'trade-blue': true,
        'white--text': true,
        grey:
          (this.product_selections_changed || this.temp_dsm_combinations_updating) &&
          !this.active_from_outside,
      };
    },
    filters_button_class() {
      return {
        'v-btn--outlined': true,

        'white--text': true,
        'trade-blue': true,
        grey: this.temp_dsm_combinations_updating,
      };
    },

    drawerOpen: {
      get() {
        if (this.selector_type === 'products') {
          return this.$store.state.tradeDSM.productsOpen;
        } else {
          return this.$store.state.tradeDSM.countriesOpen;
        }
      },
      set() {
        //pass
      },
    },
  },
  watch: {
    async drawerOpen(newv) {
      // clean the circular reference error, just in case
      this.clear_circ_ref_error();

      // clear the search query
      this.searchQuery = '';

      // set the master list for this transaction
      // this sets the list for the duration of the transaction
      // Solve this  by - maybe generating this list dynamically?

      this.set_selectors();

      this.allow_out_of_cube_items_selections = false;

      if (newv) {
        await this.$removeItem('filter-open-backup');
        await this.$setItem(
          'filter-open-backup',
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters,
        );
        // sync selectors
        this.current_transaction.combinations = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.combinations;
      }

      // if (!this.active_from_outside) {
      //   this.active_from_outside_markets = false;
      //   this.active_from_outside_products = false;
      // }

      await this.set_backup_market_selector_list();
      this.backup_current_transaction = _.clone(this.current_transaction);
    },
  },
  methods: {
    ...mapMutations(['clear_circ_ref_error', 'set_dsm_filters_from_localforage']),

    search_box_text() {
      if (this.FilterBox !== null) {
        return this.FilterBox.search_box_text;
      } else return '';
    },

    box_entries_count(box_id, allow_selections) {
      if (this.FilterBox !== null) {
        return this.FilterBox.box_entries_count(box_id, allow_selections);
      } else return 0;
    },

    represented_items_count(search_box, item) {
      if (this.FilterBox === null || search_box.id === 0) {
        return 0;
      }

      const entry = search_box.code_lookup[item];
      if (!entry) {
        return 0;
      }

      if (this.selector_type === 'products') {
        return entry.hs6_count || 0;
      }

      if (this.selector_type === 'markets') {
        const searchAndSelectList = this.FilterBox.SearchAndSelectList || [];

        if (search_box.code === 'Sub_Region') {
          return _.uniq(
            searchAndSelectList
              .filter(market => market.Sub_Region === item)
              .map(market => market.C_Code),
          ).length;
        }

        if (search_box.code === 'Main_Region') {
          return _.uniq(
            searchAndSelectList
              .filter(market => market.Main_Region === item)
              .map(market => market.C_Code),
          ).length;
        }
      }

      return 0;
    },

    set_bulk_selection_busy(isBusy) {
      this.bulk_selection_in_progress = isBusy;

      if (typeof document !== 'undefined') {
        document.body.style.cursor = isBusy ? 'wait' : '';
      }
    },

    wait_for_cursor_paint() {
      return new Promise(resolve => {
        if (typeof window !== 'undefined' && window.requestAnimationFrame) {
          window.requestAnimationFrame(() => {
            setTimeout(resolve, 0);
          });
        } else {
          setTimeout(resolve, 0);
        }
      });
    },

    async run_bulk_selection(action) {
      if (this.bulk_selection_in_progress) {
        return;
      }

      this.set_bulk_selection_busy(true);
      await this.$nextTick();
      await this.wait_for_cursor_paint();

      try {
        await action();
      } finally {
        await this.$nextTick();
        this.set_bulk_selection_busy(false);
      }
    },

    async handle_select_all(box_id) {
      await this.run_bulk_selection(() => this.select_visible_entries(box_id));
    },

    async handle_unselect_all(box_id) {
      await this.run_bulk_selection(() => {
        this.FilterBox.select_all(
          box_id,
          false,
          this.allow_out_of_cube_items_selections,
        );
      });
    },

    select_visible_entries(box_id) {
      if (this.FilterBox === null) {
        return;
      }

      if (!this.searchQuery) {
        this.FilterBox.select_all(
          box_id,
          true,
          this.allow_out_of_cube_items_selections,
        );
        return;
      }

      const visibleItems = [...this.FilterBox.box_entry_codes(box_id, this.searchQuery)];

      if (typeof this.FilterBox.select_filtered_entries === 'function') {
        this.FilterBox.select_filtered_entries(
          box_id,
          visibleItems,
          this.allow_out_of_cube_items_selections,
        );
        return;
      }

      const searchBox = this.FilterBox.search_boxes[box_id].code_lookup;

      visibleItems.forEach(item => {
        if (!searchBox[item].selected) {
          this.FilterBox.entry_click(
            box_id,
            item,
            this.allow_out_of_cube_items_selections,
          );
        }
      });
    },

    partial_select_all(id, item) {
      this.FilterBox.partial_select_all(id, item);
    },
    async entry_click(id, item) {
      if (
        !this.FilterBox.search_boxes[id].code_lookup[item].in_cube &&
        !this.allow_out_of_cube_items_selections
      ) {
        await Swal.fire({
          title: "<h6 style='font-family:Arial'>" + 'Warning' + '</h6>',
          showCancelButton: true,
          cancelButtonColor: config.trade_blue2,
          confirmButtonText: 'Enable now',
          confirmButtonColor: config.trade_blue2,
          width: '700px',
          cancelButtonText: 'Cancel',
          customClass: {
            cancelButton: 'outline_focus',
          },
          html:
            "<span style='font-family:Arial'>The item you selected is not within the current results set. " +
            '<br> You can enable this selection by selecting the `All Products`tickbox or,' +
            '<br> by selecting the `Enable now` button below. <br>' +
            '<br> If you select `Enable`, the item you clicked will also be selected.' +
            '<br> Selected items will be added to the top of the list. </span>',
        }).then(result => {
          if (result.isConfirmed) {
            this.allow_out_of_cube_items_selections = true;
          }
        });
      }
      this.FilterBox.entry_click(id, item, this.allow_out_of_cube_items_selections);

      this.searchQuery = '';
    },

    set_selectors() {
      this.FilterBox_Products = new ProductFilterBox(
        this.search_boxes_products,
        this.$store.state,
      );
      this.FilterBox_Markets = new MarketFilterBox(
        this.countriesSearchAndSelectedList,
        this.search_boxes_markets,
        this.$store.state,
      );

      this.change_selector();
    },

    change_selector() {
      if (this.selector_type === 'products') {
        this.FilterBox = this.FilterBox_Products;
      } else {
        this.FilterBox = this.FilterBox_Markets;
      }
    },
    async setup_open_from_top_selector_list_box() {
      eventBus.$on('ACTIVATE_PRODUCT_APPLY', async markets => {
        await this.$store.commit('toggleProductsFilter', true);
        this.FilterBox.select_keys(0, markets, true);
        this.FilterBox.set_all_partial_down();
        this.active_from_outside = true;
        this.active_from_outside_products = true;
        this.active_from_outside_markets = false;
        await this.update_temp_dsm_combinations();
      });
      eventBus.$on('ACTIVATE_MARKET_APPLY', async markets => {
        await this.$store.commit('toggleCountriesFilter', true);
        this.FilterBox.select_keys(0, markets, true);
        this.FilterBox.set_all_partial_down();
        this.active_from_outside = true;
        this.active_from_outside_markets = true;
        this.active_from_outside_products = false;
        await this.update_temp_dsm_combinations();
      });
    },

    show_item(item) {
      return item.toLowerCase().includes(this.searchQuery.toLowerCase());
    },

    async set_backup_market_selector_list() {
      this.backup_market_selector_list = _.cloneDeep(
        await this.FilterBox.selected_items(),
      );
    },
    apply_btn_clicked: async function() {
      // now sync the
      this.$store.state.tradeDSM.countriesOpen = false;
      this.$store.state.tradeDSM.productsOpen = false;
      if (this.selector_type === 'products') {
        // alert(`products will be set to ${await this.FilterBox.selected_items()}`);
        const selectedItems = await this.FilterBox.selected_items();
        this.$set(
          this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections
            .products,
          'HS6_Code',
          selectedItems,
        );
      } else {
        // alert(`markets will be set to ${await this.FilterBox.selected_items()}`);
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code = await this.FilterBox.selected_items();
      }

      this.$store.state.tradeDSM.countriesOpen = false;
      this.$store.state.tradeDSM.productsOpen = false;
      this.active_from_outside = false;
      this.active_from_outside_products = false;
      this.active_from_outside_markets = false;
      await this.update_results_cube();
    },
    cancel_btn_clicked: async function() {
      // reset the previous state
      // alert('me');
      this.$store.state.tradeDSM.productsOpen = false;
      this.$store.state.tradeDSM.countriesOpen = false;

      if (this.active_from_outside_products && this.selector_type === 'products') {
        eventBus.$emit('CLEAR_PRODUCTS_TOP_LIST');
      }

      if (this.active_from_outside_markets && this.selector_type !== 'products') {
        eventBus.$emit('CLEAR_MARKETS_TOP_LIST');
      }

      this.active_from_outside = false;
      this.active_from_outside_products = false;
      this.active_from_outside_markets = false;

      await this.set_dsm_filters_from_localforage(
        await this.$getItem('filter-open-backup'),
      );
    },

    allow_out_of_cube_items_selections_changed(new_value) {
      // when we uncheck this box, then we need to unselect all the out of cubes
      if (new_value === false) {
        // we need to unselect all countries that is not in the cube
        for (let i = 0; i < this.master_list.length; i++) {
          let new_item_value = _.cloneDeep(this.master_list[i]);
          if (!new_item_value.in_cube) {
            new_item_value.HS6_Code_Selected = false;
            new_item_value.HS4_Code_Selected = false;
            new_item_value.HS2_Code_Selected = false;
            new_item_value.HS2_Groups_Selected = false;
            this.$set(this.master_list, i, new_item_value);
          }
        }
      }
    },

    update_temp_dsm_combinations: async function() {
      // get dsm combinatons for the filters ,countries and products combinations
      this.temp_dsm_combinations_updating = true;
      this.clear_circ_ref_error();
      let update_data = _.cloneDeep(
        this.$store.state.tradeDSM.dsm_filter_setttings.Filters,
      );

      if (this.selector_type === 'products') {
        update_data.META.selections.products.HS6_Code = await this.FilterBox.selected_items();
        update_data.META.selections.markets.C_Code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.markets.C_Code;
      } else {
        update_data.META.selections.markets.C_Code = await this.FilterBox.selected_items();
        update_data.META.selections.products.HS6_Code = this.$store.state.tradeDSM.dsm_filter_setttings.Filters.META.selections.products.HS6_Code;
      }

      await this.axios
        .post(this.$store.getters.baseUrl + 'temp_update_markets_products/', update_data)
        .then(response => {
          this.current_transaction.combinations = response.data;
        })
        .catch(e => {
          // alert('Error in NEW market search_box_update_filters_combos');
          alert(e);
        })
        .finally(() => {
          this.temp_dsm_combinations_updating = false;
        });
    },
  },
};
</script>

<style scoped>
.outline_focus {
  margin: 2px;
  outline: orange dashed 3px;
}

.outline_focus_solid {
  margin: 2px;
  outline: orange solid 3px;
}

.hand {
  cursor: pointer;
}

.mini_box {
  background: yellow;
  margin: 1px;
  color: darkblue;
  font-size: 15px;
  outline: lightgrey solid 1px;
}

.help_box {
  font-size: 9px;
}

.not_selected {
  font-style: italic;
  border-bottom: 1px dashed grey !important;
}

.no-select {
  user-select: none; /* Standard syntax */
}

.bulk-selection-busy,
.bulk-selection-busy * {
  cursor: wait !important;
}

.bulk-selection-action-btn.v-btn--disabled {
  background-color: #bdbdbd !important;
  opacity: 1 !important;
}

.bulk-selection-check-btn.v-btn--disabled,
.bulk-selection-check-btn.v-btn--disabled .v-icon {
  color: #000 !important;
}

.p_overflow {
  /*white-space: nowrap;*/
  //overflow: hidden;
  //text-overflow: ellipsis;
}

.name {
  text-overflow: ellipsis;
  margin-bottom: 12px;
  cursor: pointer;
  word-break: break-all;
  overflow: hidden;
  white-space: nowrap;
}
.name:hover {
  white-space: normal;
  height: auto; /* just added this line */
  color: #0079c1;

  word-wrap: break-word !important;
}
</style>
